import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { IUsuarioToken } from '../model/usuario-token.interface';
import { UsuarioToken } from '../model/usuario-token.model';

@Injectable({
  providedIn: 'root'
})
export class UsuarioTokenService extends DefaultService<UsuarioToken> {

  static URL = '/api/seguranca/notificacao/usuarioToken/v1/usuarioTokens';

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) { 
    super(
      httpClient,
      errorHandler,
      UsuarioTokenService.URL
    );
  }

  public removerPorToken(token: string): Observable<any> {
    return this.remover(0, token);
  }
  
  public remover(idUsuario: number, token: string): Observable<any> {
    return this.httpClient.delete<any>(`${UsuarioTokenService.URL}/${idUsuario}/${token}`)
               .pipe (
                  map ( response => {
                    return response;
                  })
                  , catchError (err => {
                    return throwError(this.errorHandler.handle(err));
                  })
                );    
  }

}
